// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iWwcvSMzhrac6n9_uvhh{display:flex;gap:8px;margin-top:8px;align-items:center}`, "",{"version":3,"sources":["webpack://./src/entities/Conversation/ui/ConversationCard/ui/ScheduleCount/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,OAAA,CACA,cAAA,CACA,kBAAA","sourcesContent":[".wrap {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `iWwcvSMzhrac6n9_uvhh`
};
export default ___CSS_LOADER_EXPORT___;
